export { default } from "./TableSkeleton";
